import React from 'react'

import {
  Card,
  CardContent,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material'

const SpiritualRecord = (props) => {
  return (
    <Card sx={{ borderRadius: 2, p: 2 }}>
      <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography color='primary' variant='body1'>
              <b style={{ fontWeight: 900 }}>ESPIRITUAL</b>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <List disablePadding>
              <ListItem sx={{ p: 0 }}>
                <ListItemText primary={<b>Sacramentos iniciales</b>} secondary='Sin definir' />
              </ListItem>
              <ListItem sx={{ p: 0 }}>
                <ListItemText primary={<b>Asistencia a misa dominical</b>} secondary='Sin definir' />
              </ListItem>
              <ListItem sx={{ p: 0 }}>
                <ListItemText primary={<b>Momentos del día en los que reza</b>} secondary='Sin definir' />
              </ListItem>
              <ListItem sx={{ p: 0 }}>
                <ListItemText primary={<b>Lleva a dios en su día a día haciendo...</b>} secondary='Sin definir' />
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default SpiritualRecord